import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../UI/card';
import { Calendar, Clock, Users } from 'lucide-react';

const ActivitySummaryCard = ({ sessions = 0, totalHours = 0, totalInteractions = 0 }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">This Month</CardTitle>
        <CardDescription>Your activity overview</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Calendar className="h-4 w-4 text-gray-500 dark:text-gray-400" />
            <span className="text-sm text-gray-600 dark:text-gray-400">Sessions</span>
          </div>
          <span className="text-2xl font-bold text-gray-900 dark:text-white">{sessions}</span>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Clock className="h-4 w-4 text-gray-500 dark:text-gray-400" />
            <span className="text-sm text-gray-600 dark:text-gray-400">Total Hours</span>
          </div>
          <span className="text-2xl font-bold text-gray-900 dark:text-white">{totalHours}</span>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Users className="h-4 w-4 text-gray-500 dark:text-gray-400" />
            <span className="text-sm text-gray-600 dark:text-gray-400">Connections</span>
          </div>
          <span className="text-2xl font-bold text-gray-900 dark:text-white">{totalInteractions}</span>
        </div>
      </CardContent>
    </Card>
  );
};

export default ActivitySummaryCard;
